import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DAY_ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const DAY_LABELS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

export const DAY_LABELS_SHORT = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
};

// "23:00" -> "11:00 PM", "00:00" -> "12:00 AM"
export const formatTime = (hhmm) => {
  if (!hhmm || !hhmm.includes(':')) return hhmm || '';
  const [h, m] = hhmm.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  let hour = h % 12;
  if (hour === 0) hour = 12;
  return `${hour}:${String(m).padStart(2, '0')} ${period}`;
};

export const formatDayHours = (d) => {
  if (!d || d.closed) return 'Closed';
  return `${formatTime(d.open)} - ${formatTime(d.close)}`;
};

// Fetches the single source-of-truth business hours from the backend.
export const useBusinessHours = () => {
  const [hours, setHours] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/business-hours`)
      .then((res) => {
        if (active) setHours(res.data.hours);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return hours;
};
